import React from 'react'
import { COLORES } from '../../../../../config/colores'
import moment from 'moment'
import TableValueAction from '../../../../MuiTable/components/TableValueAction'
import InfoCpa from '../../../../Camiones/containers/busquedaCpa/InfoCpa'

export function getColumnasDescargaProcesada (rol) {
  const rolExportador = (rol && (rol[0] !== 'EXPORTADOR') && (rol[1] !== 'EXPORTADOR'))

  return ([
    {
      name: 'fechaDeDescarga',
      label: 'Fecha descarga',
      options: {
        filter: true,
        sort: true,
        filterType: 'multiselect',
        setCellProps: () => ({
          style: {
            position: 'sticky',
            left: '0',
            background: COLORES.grey.light,
            zIndex: 100
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            whiteSpace: 'nowrap',
            position: 'sticky',
            left: 0,
            background: 'white',
            zIndex: 101
          }
        }),
        customBodyRender: (fecha) => {
          return moment(fecha).format('DD-MM-YYYY')
        }
      }
    },
    {
      name: 'cartaDePorte',
      label: 'Carta de porte',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (numero) => {
          return (
            <>
              { numero
                ? <TableValueAction
                  value={numero}
                  title=' '
                  content={<InfoCpa cpa={numero} />} />
                : null
              }
            </>
          )
        }
      }
    },
    {
      name: 'exportador',
      label: 'Exportador',
      options: {
        filter: true,
        sort: true,
        filterType: 'multiselect',
        display: rolExportador
      }
    },
    {
      name: 'cereal',
      label: 'Cereal',
      options: {
        filter: true,
        sort: true,
        filterType: 'checkbox'
      }
    },
    {
      name: 'titular',
      label: 'Titular',
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: 'remitenteComercial',
      label: 'Remitente Comercial',
      options: {
        filter: true,
        sort: true,
        display: false
      }
    },
    {
      name: 'corredorComprador',
      label: 'Corredor Vta. Primaria',
      options: {
        filter: true,
        sort: true,
        display: false
      }
    },
    {
      name: 'corredorVendedor',
      label: 'Corredor Vta. Secundaria',
      options: {
        filter: true,
        sort: true,
        display: false
      }
    },
    {
      name: 'vendedor',
      label: 'Entregador',
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: 'pesoBruto',
      label: 'Bruto',
      options: {
        filter: false,
        sort: true
      }
    },
    {
      name: 'pesoTara',
      label: 'Tara',
      options: {
        filter: false,
        sort: true
      }
    },
    {
      name: 'pesoNeto',
      label: 'Neto',
      options: {
        filter: false,
        sort: true
      }
    },
    {
      name: 'mermaHumedad',
      label: 'Merma humedad',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (merma) => {
          return (merma > 0) ? merma : ' - '
        },
        setCellProps: () => ({
          style: {
            textAlign: 'center'
          }
        })
      }
    },
    {
      name: 'pesoNetoHumedad',
      label: 'Neto humedad',
      options: {
        filter: false,
        sort: true
      }
    },
    {
      name: 'mermaVolatil',
      label: 'Merma volatil',
      options: {
        filter: false,
        sort: true
      }
    },
    {
      name: 'pesoNetoStock',
      label: 'Neto stock',
      options: {
        filter: false,
        sort: true,
        total: true,
        customBodyRender: (neto) => {
          return <b>{neto}</b>
        }
      }
    },
    {
      name: 'humedad',
      label: 'Humedad',
      options: {
        filter: false,
        sort: true
      }
    },
    {
      name: 'fumigado',
      label: 'Fumigado',
      options: {
        filter: true,
        sort: true,
        filterType: 'checkbox'
      }
    },
    {
      name: 'transportista',
      label: 'Transportista',
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: 'chofer',
      label: 'Chofer',
      options: {
        filter: false,
        sort: true,
        display: false
      }
    },
    {
      name: 'patente',
      label: 'Patente',
      options: {
        filter: false,
        sort: true
      }
    }
  ])
}

export const DESCARGA_PROCESADA_STOCK_TO_PRINT = [
  {
    name: 'fechaDeDescarga',
    label: 'Fecha de descarga',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'exportador',
    label: 'Exportador',
    width: 90,
    mantenerCase: true
  },
  {
    name: 'cereal',
    label: 'Cereal',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'numero',
    label: 'Carta de porte',
    width: 65,
    mantenerCase: true
  },
  {
    name: 'titular',
    label: 'Titular',
    width: 80,
    mantenerCase: true
  },
  {
    name: 'pesoBruto',
    label: 'Peso Bruto',
    width: 50,
    mantenerCase: true
  },
  {
    name: 'pesoNeto',
    label: 'Peso Neto',
    width: 50,
    mantenerCase: true
  },
  {
    name: 'mermaHumedad',
    label: 'Merma humedad',
    width: 50,
    mantenerCase: true
  },
  {
    name: 'pesoNetoHumedad',
    label: 'Neto humedad',
    width: 50,
    mantenerCase: true
  },
  {
    name: 'mermaVolatil',
    label: 'Merma volatil',
    width: 50,
    mantenerCase: true
  },
  {
    name: 'fumigado',
    label: 'Fumigado',
    width: 50,
    mantenerCase: true
  },
  {
    name: 'pesoNetoStock',
    label: 'Neto stock',
    width: 50,
    mantenerCase: true
  },
  {
    name: 'transportista',
    label: 'Transportista',
    width: 80,
    mantenerCase: true
  }
]
